import type { AppData } from "@/lib/types";

export const seedData: AppData = {
  companyProfile: null,
  invoices: [],
  clients: [
    {
      id: "client-1",
      name: "Bona Ventures Client",
      company: "Bona Ventures",
      email: "client@example.com",
      phone: "(603) 555-0148",
      address: "124 Main Street, Concord, NH",
    },
    {
      id: "client-2",
      name: "North Shore Property Group",
      company: "North Shore Property Group",
      email: "office@example.com",
      phone: "(617) 555-0182",
      address: "18 Harbor Avenue, Boston, MA",
    },
  ],
  jobs: [
    {
      id: "job-1",
      clientId: "client-1",
      title: "Whole-Home Renovation",
      address: "124 Main Street, Concord, NH",
      status: "ACTIVE",
      referenceNumber: "JOB-2026-001",
      startDate: "2026-05-15",
      targetCompletion: "2026-11-30",
      projectManager: "James Mitchell",
      customerName: "Bona Ventures",
      contractAmount: 55000,
      contractType: "Lump Sum",
    },
    {
      id: "job-2",
      clientId: "client-1",
      title: "Kitchen & Bath Renovation",
      address: "48 Lakeview Drive, Laconia, NH",
      status: "ACTIVE",
      referenceNumber: "JOB-2026-002",
      contractType: "Lump Sum",
    },
    {
      id: "job-3",
      clientId: "client-2",
      title: "Unit 3 Interior Renovation",
      address: "18 Harbor Avenue, Boston, MA",
      status: "ACTIVE",
      referenceNumber: "JOB-2026-003",
      customerName: "North Shore Property Group",
      contractAmount: 9000,
      contractType: "Lump Sum",
    },
  ],
  sowItems: [
    {
      id: "sow-1",
      jobId: "job-1",
      title: "Framing",
      description: "Structural framing, blocking, headers, and rough openings.",
      contractAmount: 25000,
      approvedBudgetChanges: 0,
      approvedChangeReason: "",
    },
    {
      id: "sow-2",
      jobId: "job-1",
      title: "Rough HVAC",
      description: "Duct layout, equipment rough-in, and distribution preparation.",
      contractAmount: 18000,
      approvedBudgetChanges: 0,
      approvedChangeReason: "",
    },
    {
      id: "sow-3",
      jobId: "job-1",
      title: "Electrical Rough",
      description: "Rough wiring, boxes, and panel preparation.",
      contractAmount: 12000,
      approvedBudgetChanges: 0,
      approvedChangeReason: "",
    },
    {
      id: "sow-4",
      jobId: "job-3",
      title: "Painting",
      description: "Interior preparation, priming, and finish coats.",
      contractAmount: 9000,
      approvedBudgetChanges: 0,
      approvedChangeReason: "",
    },
    {
      id: "sow-5",
      jobId: "job-2",
      title: "Kitchen Cabinetry",
      description: "Cabinet installation, trim, hardware, and field adjustments.",
      contractAmount: 32000,
      approvedBudgetChanges: 0,
      approvedChangeReason: "",
    },
  ],
  draws: [
    {
      id: "draw-1",
      sowId: "sow-1",
      amount: 5000,
      explanation: "Framing milestone completed.",
      status: "APPROVED",
      mediaName: "framing-progress.jpg",
      estimatedArrivalDate: new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString(),
      createdAt: new Date().toISOString(),
    },
    {
      id: "draw-2",
      sowId: "sow-3",
      amount: 2000,
      explanation: "Electrical rough-in progress.",
      status: "RECEIVED",
      mediaName: "electrical-rough.jpg",
      createdAt: new Date().toISOString(),
    },
  ],
};
